import React, { useContext, useMemo } from 'react'
import { useToolsLtvNav } from '../../../lib/hooks'
import { CompactCtaContext } from '../../../contexts/compact-cta-context'
import { PlansCtaButton } from '@components/plans-cta-button'

const BUTTON_CONFIG = {
  trial: { text: 'Try Pro for free', variant: 'pro' as const, isInverted: false },
  upgrade: { text: 'Get Pro', variant: 'pro' as const, isInverted: true },
} as const

export const TrialCtaButton: React.FC = () => {
  const { isTrialEligible, trackShow } = useToolsLtvNav()
  const compact = useContext(CompactCtaContext)

  const config = useMemo(() => {
    return isTrialEligible ? BUTTON_CONFIG.trial : BUTTON_CONFIG.upgrade
  }, [isTrialEligible])

  return (
    <PlansCtaButton
      wrapper="cta"
      variant={config.variant}
      size={compact ? 'small' : 'medium'}
      text={config.text}
      isInverted={config.isInverted}
      onShow={trackShow}
    />
  )
}
